import React, { Component } from "react";
import { connect } from "react-redux";
import { changeSwModeAction } from "../../redux/app/actions";
import { changeCsLineAction } from "../../redux/csDsp/actions";
import { openProbAction } from "../../redux/ui/actions";
import Lgd, { probLgd } from "../common/Lgd";
import Sw from "../common/Sw";

const mapStateToProps = (state) => {
    return {
        swMode: state.appReducer.swMode,
        XList: state.csDspReducer.XList,
        YList: state.csDspReducer.YList,
        YLineList: state.csDspReducer.YLineList,
        bList2: state.csDspReducer.bList2,
        probList: state.csDspReducer.probList,
        scrTop: state.csDspReducer.scrTop,
        scrLeft: state.csDspReducer.scrLeft,
    };
};

class Main extends Component {
    constructor(props) {
        super(props);
        this.closeSw = this.closeSw.bind(this);

        this.scaleXRef = React.createRef();
        this.scaleYRef = React.createRef();
        this.mainRef = React.createRef();
    }

    /*
     * 目盛スクロール
     * @param {Event} e イベント情報
     * @since hara 2020-09-09
     */
    doScroll(e) {
        this.scaleYRef.scrollTop = e.target.scrollTop;
        this.scaleXRef.scrollLeft = e.target.scrollLeft;
    }

    /*
     * サブウィンドウを閉じる
     * @since hara 2020-10-26
     */
    closeSw() {
        this.props.dispatch(openProbAction(false));
    }

    render() {
        return (
            <Sw title="予測表示" focusName="prob">
                <div className="l-flex l-mtS">
                    <div className="CSDsp">
                        <div className="l-flex">
                            <div className="CSDsp__corner"></div>
                            <div id="sepSw_XList" className="CSDsp__x" ref={(ref) => (this.scaleXRef = ref)}>
                                {this.props.XList}
                            </div>
                        </div>
                        <div className="CSDsp__wrap">
                            <div id="sepSw_YList" className="CSDsp__y" ref={(ref) => (this.scaleYRef = ref)}>
                                {this.props.YList}
                            </div>
                            <div id="sepSw_main" className="CSDsp__main" onScroll={(e) => this.doScroll(e)} ref={(ref) => (this.mainRef = ref)}>
                                <div className="CSDsp__main__layer">{this.props.probList}</div>
                                {this.props.bList2}
                                {this.props.YLineList}
                            </div>
                        </div>
                    </div>
                    <div className="l-mlM">
                        <Lgd data={probLgd} cat="prob" />
                    </div>
                </div>

                <div className="l-right l-mtM">
                    <button className="cBtn" onClick={this.closeSw}>
                        閉じる
                    </button>
                </div>
            </Sw>
        );
    }
}

export default connect(mapStateToProps)(Main);
